import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ChangePassword from "../../components/User/ChangePassword";

export default withRouter(connect()(ChangePassword));
